import { FaUserTie, FaLightbulb, FaChartBar, FaHandshake, FaDollarSign, FaRocket } from 'react-icons/fa';

export const consultationServiceData = {
  slug: 'consultation-services',
  title: 'Technology Consultation Arizona | Software Strategy Phoenix Scottsdale',
  metaDescription: 'Expert technology consultation services in Arizona. Strategic software planning, digital transformation, and tech advisory for Phoenix and Scottsdale businesses.',
  keywords: [
    'technology consultant Arizona',
    'software consultation Phoenix',
    'digital transformation Arizona',
    'tech strategy Phoenix',
    'IT consultation Arizona',
    'software planning Phoenix',
    'technology advisor Arizona',
    'business technology Phoenix'
  ],
  
  hero: {
    title: 'Strategic Technology Guidance for Business Growth',
    subtitle: 'Expert consultation to help you make informed technology decisions, avoid costly mistakes, and maximize your software investments.',
    stats: [
      { number: '200%', label: 'ROI Improvement' },
      { number: '$100K+', label: 'Savings Identified' },
      { number: '90%', label: 'Success Rate' }
    ]
  },

  whyChooseUs: {
    title: 'Why You Need Technology Consultation',
    benefits: [
      {
        icon: <FaUserTie />,
        title: 'Expert Guidance',
        description: 'Get unbiased advice from a technology expert with years of experience across multiple industries and platforms. Avoid costly mistakes and make informed decisions with guidance from someone who has seen what works and what doesn\'t.'
      },
      {
        icon: <FaLightbulb />,
        title: 'Strategic Planning',
        description: 'Develop comprehensive technology roadmaps aligned with your business goals and growth objectives. Create step-by-step implementation plans that prioritize high-impact initiatives and maximize your technology investments.'
      },
      {
        icon: <FaChartBar />,
        title: 'Risk Assessment',
        description: 'Identify potential technology risks and develop mitigation strategies to protect your business investments. Proactive risk management prevents costly downtime, security breaches, and integration failures.'
      },
      {
        icon: <FaHandshake />,
        title: 'Vendor Selection',
        description: 'Get expert help choosing the right software, platforms, and technology partners for your specific needs. Navigate complex vendor landscapes and negotiations with confidence, ensuring you get the best value and fit.'
      },
      {
        icon: <FaDollarSign />,
        title: 'Cost Optimization',
        description: 'Identify opportunities to reduce technology costs while improving performance and capabilities. Most clients save 20-40% on their technology expenses through strategic optimization and vendor renegotiation.'
      },
      {
        icon: <FaRocket />,
        title: 'Accelerated Growth',
        description: 'Leverage technology as a competitive advantage to scale faster and more efficiently. Strategic technology implementations can reduce time-to-market by months and increase operational capacity significantly.'
      }
    ]
  },

  process: {
    title: 'Our Consultation Process',
    description: 'A comprehensive approach to understanding your needs and delivering actionable technology recommendations.',
    steps: [
      {
        title: 'Business Assessment',
        description: 'Analyze your current technology landscape, business processes, and strategic objectives to identify opportunities.'
      },
      {
        title: 'Technology Audit',
        description: 'Evaluate existing systems, identify gaps, inefficiencies, and areas for improvement or modernization.'
      },
      {
        title: 'Strategic Recommendations',
        description: 'Develop detailed recommendations with implementation roadmap, timelines, and expected ROI analysis.'
      },
      {
        title: 'Implementation Support',
        description: 'Provide ongoing guidance during implementation to ensure successful execution of recommended solutions.'
      }
    ]
  },

  technologies: {
    title: 'Areas of Expertise',
    items: [
      'Digital Transformation',
      'Software Architecture',
      'Cloud Strategy',
      'CRM Selection & Implementation',
      'Business Process Optimization',
      'Technology Stack Planning',
      'Vendor Evaluation',
      'Security Assessment',
      'Scalability Planning',
      'Integration Strategy',
      'ROI Analysis',
      'Change Management'
    ]
  },

  results: {
    title: 'Consultation Outcomes',
    items: [
      {
        metric: '200%',
        description: 'Average ROI improvement from recommendations'
      },
      {
        metric: '$100K+',
        description: 'Average cost savings identified per client'
      },
      {
        metric: '6 months',
        description: 'Faster time to market for new initiatives'
      },
      {
        metric: '90%',
        description: 'Client satisfaction with strategic outcomes'
      }
    ]
  },

  faq: {
    title: 'Consultation FAQ',
    items: [
      {
        question: 'What does a technology consultation include?',
        answer: 'Our consultations include a comprehensive assessment of your current technology, identification of opportunities, strategic recommendations, implementation roadmap, and ongoing support during execution.'
      },
      {
        question: 'How long does a consultation project take?',
        answer: 'Initial assessments typically take 1-2 weeks, while comprehensive strategic planning can take 4-6 weeks. Timeline depends on business complexity and scope of evaluation.'
      },
      {
        question: 'Do you work with businesses of all sizes?',
        answer: 'Yes, we provide consultation services for small startups to large enterprises. Our approach scales to match your business size, budget, and complexity requirements.'
      },
      {
        question: 'Can you help us avoid technology mistakes?',
        answer: 'Absolutely. One of our key values is helping businesses avoid costly technology mistakes by providing expert guidance on vendor selection, architecture decisions, and implementation strategies.'
      },
      {
        question: 'Do you provide implementation services too?',
        answer: 'Yes, after consultation we can provide full implementation services, or we can work with your preferred vendors and internal teams to ensure successful execution of recommendations.'
      }
    ]
  },

  schema: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Technology Consultation Services",
    "description": "Expert technology consultation and strategic planning services for Arizona businesses",
    "provider": {
      "@type": "Person",
      "name": "Daniel Rangel",
      "telephone": "+1-480-282-0569",
      "email": "daniel@danielrayrangel.com"
    },
    "areaServed": {
      "@type": "State",
      "name": "Arizona"
    },
    "serviceType": "Technology Consultation",
    "offers": {
      "@type": "Offer",
      "description": "Strategic technology consultation, digital transformation, and software planning services"
    }
  }
};